export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  "6LfXxuItAAAAACGPckjlQPHflfS2bbs2-LQx96UA";

/**
 * Ensures Google reCAPTCHA v3 script is loaded and ready
 */
export const loadRecaptchaScript = () => {
  return new Promise((resolve) => {
    if (typeof window === "undefined") {
      return resolve(false);
    }

    if (window.grecaptcha && window.grecaptcha.execute) {
      return resolve(true);
    }

    const scriptId = "google-recaptcha-v3-script";
    let script = document.getElementById(scriptId);

    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    const checkReady = () => {
      if (window.grecaptcha && window.grecaptcha.execute) {
        window.grecaptcha.ready(() => resolve(true));
      } else {
        setTimeout(checkReady, 100);
      }
    };

    script.onload = () => {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => resolve(true));
      } else {
        checkReady();
      }
    };

    script.onerror = () => {
      console.warn("Could not load Google reCAPTCHA script.");
      resolve(false);
    };

    // Timeout fallback after 4 seconds
    setTimeout(() => {
      if (window.grecaptcha && window.grecaptcha.execute) {
        resolve(true);
      } else {
        resolve(false);
      }
    }, 4000);
  });
};

/**
 * Execute reCAPTCHA v3 and get verification token
 * @param {string} action
 * @returns {Promise<string>}
 */
export const getRecaptchaToken = async (action = "submit") => {
  try {
    const isLoaded = await loadRecaptchaScript();
    if (!isLoaded || !window.grecaptcha || !window.grecaptcha.execute) {
      console.warn("reCAPTCHA is unavailable or blocked.");
      return "";
    }

    return await new Promise((resolve) => {
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
            action,
          });
          resolve(token || "");
        } catch (err) {
          console.error("reCAPTCHA execution error:", err);
          resolve("");
        }
      });
    });
  } catch (err) {
    console.error("Failed to generate reCAPTCHA token:", err);
    return "";
  }
};
